module.exports = __webpack_public_path__ + "static/media/member_02.b7903e4b.jpg";